import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { BenefitService } from 'src/app/benefits/shared/benefit.service';
import { MembershipLevelDto } from 'src/app/benefits/shared/dto/membership-level.dto';
import { PagedResultGeneric } from 'src/app/shared';
import { MembershipLevelMetadataItemDto } from '../../shared/dto/membership-level-metadata-item.dto';
import { MembershipLevelMetadataLego } from '../../shared/dto/membership-level-metadata.lego';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-membership-level-lego-edit',
  templateUrl: './membership-level-lego-edit.component.html',
  styleUrls: ['./membership-level-lego-edit.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class MembershipLevelLegoEditComponent implements OnInit, OnChanges {
  membershipLevels: Array<SelectItem>;
  selectedLevel: number;
  @Input() membershipLevelData: MembershipLevelMetadataLego;

  constructor(private _benefitService: BenefitService) {}

  ngOnInit(): void {
    this._benefitService.getMembershipLevels().then((data) => {
      this.membershipLevels = data.Result.map((x) => {
        return { label: x.Name, value: x.MembershipLevelId } as SelectItem;
      });
      if (this.membershipLevelData?.MembershipLevelItems?.length) {
        this.cleanUpItems();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.membershipLevelData && this.membershipLevels?.length) {
      this.cleanUpItems();
    }
  }

  /*
   * clean up any existing items that may have changed names or membership levels have been deleted
   */
  cleanUpItems() {
    for (let item of this.membershipLevelData.MembershipLevelItems.filter((i) =>
      this.membershipLevels.some((m) => m.value == i.MembershipLevelId && m.value != i.RealName)
    )) {
      item.RealName = this.membershipLevels.find((x) => x.value == item.MembershipLevelId).label;
    }
    for (let item of this.membershipLevelData.MembershipLevelItems.filter(
      (i) => !this.membershipLevels.some((x) => x.value == i.MembershipLevelId)
    )) {
      this.removeItem(item);
    }
  }

  removeItem(item: MembershipLevelMetadataItemDto) {
    const index = this.membershipLevelData.MembershipLevelItems.indexOf(item);
    this.membershipLevelData.MembershipLevelItems.splice(index, 1);
  }

  membershipLevelDropdownChanged() {
    if (!this.membershipLevelData.MembershipLevelItems.some((x) => x.MembershipLevelId == this.selectedLevel)) {
      let selectItem = this.membershipLevels.find((x) => x.value == this.selectedLevel);
      this.membershipLevelData.MembershipLevelItems.push({
        MembershipLevelId: this.selectedLevel,
        RealName: selectItem.label,
      } as MembershipLevelMetadataItemDto);
    }
  }
}
